import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import styles from "../../Stylesheets/NotFound.module.css";
import { useTranslation} from "react-i18next";
import i18n from "../../contexts/I18n";
import Cookies from "js-cookie";

const ServerError = () => {
    const { t } = useTranslation();

    // to get the body back after error page
    useEffect(() => {
        document.body.classList.add(styles.errorBackground);
        return () => {
            document.body.classList.remove(styles.errorBackground);
        };
    }, []);

    useEffect(() => {
        const savedLang = Cookies.get('language');
        if (savedLang) {
            i18n.changeLanguage(savedLang);
        }
    }, [i18n]);

    return (       
        <>
            <img src="/error/500gif.gif" alt="500 Server Error" className={styles.img_404} />
            <div className={styles.not_found_container}>
                <Link to="/" className={styles.home_link}>{t('error.goHome')}</Link>
            </div>
        </>
    );
};
  
export default ServerError;